import _slicedToArray from "/codebuild/output/src196865849/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRef, useState, useEffect, useLayoutEffect } from "react";
export var useHover = function useHover() {
  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      e = _useState2[0],
      t = _useState2[1],
      n = useRef(null),
      o = function o() {
    return t(!0);
  },
      s = function s() {
    return t(!1);
  };

  return useEffect(function () {
    var e = n.current;
    return e ? (e.addEventListener("mouseenter", o), e.addEventListener("mouseleave", s), e.addEventListener("focusin", o), e.addEventListener("focusout", s), function () {
      e.removeEventListener("mouseenter", o), e.removeEventListener("mouseleave", s), e.removeEventListener("focusin", o), e.removeEventListener("focusout", s);
    }) : function () {};
  }, []), [n, e];
};
export var useWindowSize = function useWindowSize() {
  var e = "object" == typeof window;

  function t() {
    return {
      width: e ? window.innerWidth : void 0,
      height: e ? window.innerHeight : void 0
    };
  }

  var _useState3 = useState(t),
      _useState4 = _slicedToArray(_useState3, 2),
      n = _useState4[0],
      o = _useState4[1];

  return useEffect(function () {
    if (e) return window.addEventListener("resize", n), function () {
      return window.removeEventListener("resize", n);
    };

    function n() {
      o(t());
    }
  }, []), n;
};
export var useMediaQuery = function useMediaQuery(e) {
  var t = e.replace(/^@media( ?)/m, ""),
      n = window.matchMedia(t),
      _useState5 = useState(function () {
    return n.matches;
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      o = _useState6[0],
      s = _useState6[1],
      r = function r() {
    s(window.matchMedia(t).matches);
  };

  return useEffect(function () {
    return n.addListener(r), function () {
      n.removeListener(r);
    };
  }), o;
};
export var useDisableScroll = function useDisableScroll(e) {
  useEffect(function () {
    document.documentElement.style.cssText = e ? "height: 100vh; overflow: hidden" : "";
  }, [e]);
};
export var useLockBodyScroll = function useLockBodyScroll() {
  useLayoutEffect(function () {
    return document.documentElement.style.cssText = "height: 100vh; overflow: hidden", function () {
      document.documentElement.style.cssText = "";
    };
  }, []);
};
export var useFocusTrap = function useFocusTrap(e, t) {
  useEffect(function () {
    if (e.current && document) {
      var _t = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          n = e.current.querySelectorAll(_t),
          o = n[0],
          s = n[n.length - 1],
          r = function r(e) {
        ("Tab" === e.key || 9 === e.keyCode) && (e.shiftKey ? document.activeElement === o && (s.focus(), e.preventDefault()) : document.activeElement === s && (o.focus(), e.preventDefault()));
      };

      return o.focus(), document.addEventListener("keydown", r), function () {
        document.removeEventListener("keydown", r);
      };
    }

    return function () {};
  }, [t]);
};